import React from 'react';

interface ProgressBarProps {
  currentMultiplier: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ currentMultiplier }) => {
  // Calculate progress percentage
  const progress = ((currentMultiplier - 1) / 12) * 100;
  
  return (
    <div className="mb-6">
      <div className="flex justify-between text-sm text-slate-600 dark:text-slate-400 mb-1">
        <span>Progress</span>
        <span>{currentMultiplier - 1}/12</span>
      </div>
      <div className="h-2 bg-slate-100 dark:bg-slate-700 rounded-full overflow-hidden">
        <div 
          className="h-full bg-indigo-600 dark:bg-indigo-500 transition-all duration-300 ease-out"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </div>
  );
};

export default ProgressBar;